/**
 * IconButton — 用于 block 操作栏、导航图标
 */

import { ButtonHTMLAttributes, forwardRef } from 'react';

export type IconButtonSize = 'sm' | 'md' | 'lg';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: IconButtonSize;
}

const sizeClasses: Record<IconButtonSize, string> = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = 'md', className = '', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`inline-flex items-center justify-center rounded-md text-charcoal dark:text-charcoal-light hover:bg-warm-white dark:hover:bg-warm-dark transition-colors focus:outline-none focus:ring-2 focus:ring-oasis disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses[size]} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
